Vue.component("Login", {
    props: ["config"],

    data () {
        return {
            redirectRoute: "",
        }
    },
    template: `
    
        <div class="Login">
            <TkLogin></TkLogin>
        </div>


    `,

    mounted () {

    },

    destroyed () {


    },

    methods: {

    }
});